export default __webpack_public_path__ + "static/media/Redirect.3fde7fd6.svg";